export const CONTACT_EMAIL = "CamarcaDigitalDesigns@gmail.com";
export const LOCATION = "Cincinnati, Ohio & Beyond";

export const SOCIALS = {
    facebook: "https://www.facebook.com/profile.php?id=61589260240016",
};

export const marqueeItems = [
    "Web Design",
    "Logo Design",
    "Branding Kits",
    "Cincinnati, OH",
    "Serving Nationwide",
];

export const services = [
    {
        id: "website-design",
        icon: "MonitorSmartphone",
        title: "Website Design",
        price: "From $150",
        tagline:
            "Custom, mobile-friendly websites built to make your business look legit and turn visitors into paying customers.",
        bullets: [
            "Starter & business websites",
            "Mobile-responsive layouts",
            "Quote & contact flows",
            "SEO-ready structure",
        ],
    },
    {
        id: "logo-design",
        icon: "PenTool",
        title: "Logo Design",
        price: "$60",
        tagline:
            "Clean, custom logo concepts that give your business a sharper, more professional first impression.",
        bullets: [
            "Custom logo direction",
            "Color styling",
            "Digital delivery",
            "Business-ready look",
        ],
    },
    {
        id: "branding-kits",
        icon: "Palette",
        title: "Branding Kits",
        price: "$70",
        tagline:
            "A complete visual direction for your business so your website, Facebook page, and graphics all match.",
        bullets: [
            "Logo styling",
            "Color palette",
            "Font direction",
            "Brand consistency",
        ],
    },
    {
        id: "website-updates",
        icon: "RefreshCw",
        title: "Website Updates",
        price: "$200",
        tagline:
            "Updates that keep your website fresh when your prices, photos, wording, or services change.",
        bullets: [
            "Text changes",
            "Price updates",
            "Image swaps",
            "Minor page edits",
        ],
    },
    {
        id: "ongoing-support",
        icon: "LifeBuoy",
        title: "Ongoing Support",
        price: "Custom",
        tagline:
            "Help with digital design needs as your business grows and your online presence changes.",
        bullets: [
            "Design help",
            "Site guidance",
            "Basic digital support",
            "Brand consistency",
        ],
    },
];

export const featuredProject = {
    name: "ASAP & CO. Custom Print Group",
    category: "Web Design & Branding",
    description:
        "A full custom website built with a bold red, black, and white brand style for a custom print and apparel business. The site highlights services, apparel, DTF transfers, UV printing, stickers, business branding, bulk orders, quote requests, and customer ordering.",
    deliverables: ["Custom Website", "Brand Styling", "Quote Flow", "Pricing Layout", "Work Showcase"],
    images: [
        { src: "/assets/newest-asap-home.webp", alt: "ASAP & CO. Custom Print Group homepage designed by Camarca Digital Designs", caption: "Homepage" },
        { src: "/assets/newest-asap-work-why.webp", alt: "ASAP & CO. work showcase and why choose us section", caption: "Work Showcase" },
        { src: "/assets/newest-asap-pricing.webp", alt: "ASAP & CO. organized pricing page layout", caption: "Pricing Page" },
    ],
};

export const clientProjects = [
    {
        slug: "rooted-business-advisors",
        name: "Rooted Business Advisors",
        category: "Bookkeeping & Financial Advisory",
        location: "Cincinnati, OH",
        url: "https://rootedbusinessadvisors.com",
        image: "/assets/client-rooted.webp",
        alt: "Rooted Business Advisors bookkeeping website designed by Camarca Digital Designs",
        blurb: "Advisory site with service breakdowns, proven-results highlights, and a consultation request flow.",
    },
    {
        slug: "briars-unlimited",
        name: "Briars Unlimited",
        category: "Custom Apparel & Printing",
        location: "New Jersey",
        url: "https://www.briarsunlimited.com",
        image: "/assets/client-briars.webp",
        alt: "Briars Unlimited custom apparel website designed by Camarca Digital Designs",
        blurb: "Full storefront with shop, gallery, and quote flow for a family-owned apparel business.",
    },
    {
        slug: "gap-outdoors",
        name: "GAP Outdoors",
        category: "Trailers & Sheds",
        location: "Williamsburg, OH",
        url: "https://www.gapoutdoors.com",
        image: "/assets/client-gap.webp",
        alt: "GAP Outdoors trailer and shed dealership website designed by Camarca Digital Designs",
        blurb: "Dealership site with live inventory, rent-to-own, and financing applications.",
    },
    {
        slug: "kinetic-facilities",
        name: "Kinetic Facilities",
        category: "Floor Safety & Pressure Washing",
        location: "Cincinnati, OH",
        url: "https://www.kineticfacilities.com",
        image: "/assets/client-kinetic.webp",
        alt: "Kinetic Facilities non-slip floor treatment website designed by Camarca Digital Designs",
        blurb: "Service site for an authorized Sure Step distributor with a built-in quote flow.",
    },
    {
        slug: "seraphina-collective",
        name: "Seraphina Collective",
        category: "Medical Aesthetics & Wellness",
        location: "",
        url: "https://seraphinacollective.net",
        image: "/assets/client-seraphina.webp",
        alt: "Seraphina Collective medical aesthetics website designed by Camarca Digital Designs",
        blurb: "Medspa site with services, financing info, and online consultation booking.",
    },
    {
        slug: "skinplicity-wellness",
        name: "Skinplicity Wellness",
        category: "Aesthetic Medical Center",
        location: "Kentucky & Ohio",
        url: "https://www.skinplicitywellness.com",
        image: "/assets/client-skinplicity.webp",
        alt: "Skinplicity Wellness aesthetic medical center website designed by Camarca Digital Designs",
        blurb: "Three-location medspa with team bios, full pricing, and online booking.",
    },
];

export const conceptProjects = [
    { name: "Auto Body Concept", category: "Auto Service", image: "/assets/auto-body-before-after.webp", alt: "Auto body shop website design concept" },
    { name: "HVAC Concept", category: "Home Service", image: "/assets/hvac-before-after.webp", alt: "HVAC company website design concept" },
    { name: "Lawn Care Concept", category: "Local Service", image: "/assets/lawn-care-before-after.webp", alt: "Lawn care business website design concept" },
    { name: "Plumbing Concept", category: "Trade Business", image: "/assets/plumbing-before-after.webp", alt: "Plumbing business website design concept" },
    { name: "Pressure Washing Concept", category: "Before & After Focus", image: "/assets/pressure-washing-before-after.webp", alt: "Pressure washing website design concept" },
    { name: "Salon Concept", category: "Beauty Brand", image: "/assets/salon-before-after.webp", alt: "Salon website design concept" },
];

export const pricingPlans = [
    {
        name: "Starter Website",
        price: "$150",
        description: "Starter website design with essential sections, contact information, and a professional layout.",
        stripe: null,
        featured: false,
    },
    {
        name: "Business Website",
        price: "From $250",
        description: "Custom multipage website design for a business, brand, creator, or individual project. Basic multipage builds start at $250 — most land around $450 depending on the amount of work involved.",
        stripe: null,
        featured: true,
    },
    {
        name: "Logo Design",
        price: "$60",
        description: "Custom logo design service for a business, brand, creator, or personal project.",
        stripe: "https://buy.stripe.com/4gMeVd0kVcKt6up76K9EI02",
        featured: false,
    },
    {
        name: "Branding Kit",
        price: "$70",
        description: "Basic branding kit with coordinated colors, fonts, and visual style direction.",
        stripe: "https://buy.stripe.com/bJebJ17Nn39T9GBfDg9EI03",
        featured: false,
    },
    {
        name: "Website Update",
        price: "$200",
        description: "Website update service for text changes, image swaps, small layout edits, or content updates.",
        stripe: null,
        featured: false,
    },
];

export const faqs = [
    {
        q: "Do I need a logo already?",
        a: "No. I can build around your current logo or help create a new one from scratch.",
    },
    {
        q: "Can I request changes?",
        a: "Yes. The whole point is to make the design fit your business and look professional — revisions are part of the process.",
    },
    {
        q: "What industries do you build websites for?",
        a: "Any of them. Medspas, print shops, contractors, dealerships, salons, and everything in between — every site is designed around your business, no matter what you do.",
    },
    {
        q: "Do you work only in Cincinnati?",
        a: "No. Camarca Digital Designs is based in Cincinnati, Ohio, but works with businesses of any size, locally and nationwide.",
    },
    {
        q: "How much does a website cost?",
        a: "Starter websites begin at $150 and multipage business websites from $250, with e-commerce projects involving heavier integration closer to $600. A 40% deposit starts the work, and the rest is due when your website is complete.",
    },
    {
        q: "How do we get started?",
        a: "Submit the Request a Quote form with your project details. You'll receive an email reply with next steps, and work begins once payment is confirmed.",
    },
];

export const serviceOptions = [
    "Free Homepage Preview",
    "Website Design",
    "E-Commerce Website",
    "Logo Design",
    "Branding Kit",
    "Website Updates",
    "Other",
];

export const budgetOptions = ["Under $100", "$100 – $250", "$250 – $500", "$500+"];
export const timelineOptions = ["ASAP", "This week", "This month", "Flexible"];

export const mockupOffer = {
    enabled: true,
    heading: "Not ready to commit? Get a free homepage preview.",
    text: "Send me your business name and what you do — I'll design a homepage mockup so you can see your new look before you pay a dime. Keep it only if you love it.",
    ctaLabel: "Claim My Free Preview",
};

export const reviews = [
    { quote: "I love it!", name: "Toneia", org: "Briars Unlimited" },
    { quote: "WOW! It looks so good!!", name: "Toneia's sister-in-law", org: "on the Briars Unlimited site" },
    { quote: "It looks so much better! So excited!", name: "Ali", org: "Skinplicity Wellness" },
    { quote: "I will spread the word! I like the ease of yours way better!", name: "GAP Outdoors", org: "Trailers & Sheds, Williamsburg OH" },
    { quote: "Amazing. I love how this is set up. So easy to navigate.", name: "GAP Outdoors", org: "on the admin page" },
    { quote: "We love it! It's so professional!", name: "GAP Outdoors", org: "Trailers & Sheds, Williamsburg OH" },
];

export const caseStudies = [
    {
        slug: "rooted-business-advisors",
        name: "Rooted Business Advisors",
        category: "Bookkeeping & Financial Advisory",
        location: "Cincinnati, OH",
        url: "https://rootedbusinessadvisors.com",
        image: "/assets/client-rooted.webp",
        alt: "Rooted Business Advisors bookkeeping website designed by Camarca Digital Designs",
        headline: "Nearly two decades of expertise, finally visible online.",
        story: [
            "Rooted Business Advisors handles bookkeeping, payroll oversight, and financial advisory for small businesses across Greater Cincinnati and Southeast Indiana — a trust-driven service where credibility decides the client.",
            "The build leans into the brand: a warm, rooted-in-nature design with services explained in plain English, proven results up front (including $195K in tax overpayments recovered for a client), and a consultation request flow that turns visitors into conversations.",
        ],
        features: [
            "Consultation request flow",
            "Six plain-English service pages",
            "Proven-results metrics section",
            "Values-driven about story",
            "Scrolling services marquee",
            "Mobile-first contact CTAs",
        ],
    },
    {
        slug: "asap-co",
        name: "ASAP & CO. Custom Print Group",
        category: "Custom Print & Apparel",
        location: "",
        url: "https://www.asapcustomprints.com",
        image: "/assets/newest-asap-home.webp",
        alt: "ASAP & CO. Custom Print Group website designed by Camarca Digital Designs",
        headline: "A print shop storefront that takes orders, not just calls.",
        story: [
            "ASAP & CO. needed a site as bold as their prints — one that could show real product work, lay out pricing clearly, and take quote requests instead of playing phone tag.",
            "The build pairs a red, black, and white brand system with dedicated sections for DTF transfers, UV printing, stickers, and bulk orders — so customers know exactly what to ask for before they ever reach out.",
        ],
        features: ["Custom website design", "Brand styling", "Quote request flow", "Organized pricing tables", "Visual work showcase", "Social & contact integration"],
    },
    {
        slug: "briars-unlimited",
        name: "Briars Unlimited",
        category: "Custom Apparel & Printing",
        location: "New Jersey",
        url: "https://www.briarsunlimited.com",
        image: "/assets/client-briars.webp",
        alt: "Briars Unlimited custom apparel website designed by Camarca Digital Designs",
        headline: "A family print shop with a full online store.",
        story: [
            "Briars Unlimited is a family-run print shop in New Jersey that needed to look as established online as they are in person.",
            "The site carries a full shop, product catalog, and gallery with a quote-first flow — all built around their no-minimums, fast-turnaround promise.",
        ],
        features: ["Online shop", "Product catalog", "Project gallery", "Quote request flow", "Services pages", "Family brand story"],
    },
    {
        slug: "gap-outdoors",
        name: "GAP Outdoors",
        category: "Trailers & Sheds",
        location: "Williamsburg, OH",
        url: "https://www.gapoutdoors.com",
        image: "/assets/client-gap.webp",
        alt: "GAP Outdoors trailer and shed dealership website designed by Camarca Digital Designs",
        headline: "Big-ticket inventory, built for trust.",
        story: [
            "GAP Outdoors sells trailers and sheds in Williamsburg, Ohio — big-ticket purchases where trust decides the sale.",
            "The build includes live inventory with photos and pricing, rent-to-own and financing applications, Google reviews, and visit info with maps — everything a buyer needs before driving out to the lot.",
        ],
        features: ["Live inventory system", "Rent-to-own application", "Financing application", "Google reviews section", "Location & hours with maps", "Buy, sell & trade flow"],
    },
    {
        slug: "kinetic-facilities",
        name: "Kinetic Facilities",
        category: "Floor Safety & Pressure Washing",
        location: "Cincinnati, OH",
        url: "https://www.kineticfacilities.com",
        image: "/assets/client-kinetic.webp",
        alt: "Kinetic Facilities non-slip floor treatment website designed by Camarca Digital Designs",
        headline: "Making an unfamiliar service an easy yes.",
        story: [
            "Kinetic Facilities needed to explain a product most people have never heard of — Sure Step non-slip floor treatment — and make the phone ring.",
            "The site leads with the safety message, shows every floor type the treatment works on, and keeps a call button and quote form one tap away at all times.",
        ],
        features: ["Service education sections", "Floor-type showcase", "Quote request form", "Click-to-call buttons", "Authorized distributor display", "Pressure washing section"],
    },
    {
        slug: "seraphina-collective",
        name: "Seraphina Collective",
        category: "Medical Aesthetics & Wellness",
        location: "",
        url: "https://seraphinacollective.net",
        image: "/assets/client-seraphina.webp",
        alt: "Seraphina Collective medical aesthetics website designed by Camarca Digital Designs",
        headline: "A medspa site as calm as the care.",
        story: [
            "Seraphina Collective is a private medspa built around one-on-one care — the site needed to feel calm, premium, and trustworthy from the first scroll.",
            "It presents services, before-and-after proof, reviews, and financing options, with every page one click away from online consultation booking.",
        ],
        features: ["Service pages", "Before & after gallery", "Reviews section", "Financing information", "Online booking integration", "New client special banner"],
    },
    {
        slug: "skinplicity-wellness",
        name: "Skinplicity Wellness",
        category: "Aesthetic Medical Center",
        location: "Kentucky & Ohio",
        url: "https://www.skinplicitywellness.com",
        image: "/assets/client-skinplicity.webp",
        alt: "Skinplicity Wellness aesthetic medical center website designed by Camarca Digital Designs",
        headline: "Three locations. One seamless site.",
        story: [
            "Skinplicity Wellness runs aesthetic medical centers across Kentucky and Ohio — the site had to serve every location without confusing a single visitor.",
            "The build covers team bios, transparent per-treatment pricing, location cards with maps, and online booking woven throughout — a full redesign the client called 'so much better.'",
        ],
        features: ["Multi-location pages", "Team bios", "Treatment pricing list", "Online booking integration", "Before & after section", "Contact & hours hub"],
    },
];

export const industries = [
    {
        slug: "medspa-website-design",
        label: "Medspa & Aesthetics",
        h1: "Medspa Website Design",
        seoTitle: "Medspa Website Design | Medical Aesthetics Web Designer — Camarca Digital Designs",
        seoDescription: "Medspa website design with online booking, before & after galleries, treatment pricing and financing info. See real medspa and aesthetics sites built by Camarca Digital Designs.",
        intro: "Your clients book with their eyes first. A medspa website has to feel calm, premium, and trustworthy before anyone lets you near their skin — and it has to make booking effortless.",
        image: "/assets/client-skinplicity.webp",
        imageAlt: "Skinplicity Wellness medspa website designed by Camarca Digital Designs",
        needs: [
            "Online booking integration",
            "Before & after galleries",
            "Treatment menus with pricing",
            "Financing & payment options",
            "Reviews & trust signals",
            "Multi-location support",
        ],
        paragraphs: [
            "I've built websites for medical aesthetics and wellness businesses — including Seraphina Collective, a private medspa with online consultation booking and financing information, and Skinplicity Wellness, a three-location aesthetic medical center with team bios, transparent treatment pricing, and booking woven through every page.",
            "Every medspa site I build keeps booking one click away, shows real before-and-after proof, and explains treatments in plain language — so visitors feel informed and cared for instead of sold to.",
        ],
        clients: ["skinplicity-wellness", "seraphina-collective"],
        cta: "Run a medspa or aesthetics practice?",
    },
    {
        slug: "print-shop-website-design",
        label: "Print Shops & Apparel",
        h1: "Print Shop & Custom Apparel Website Design",
        seoTitle: "Print Shop & Custom Apparel Website Design — Camarca Digital Designs",
        seoDescription: "Website design for print shops and custom apparel businesses: online shops, product catalogs, work galleries and quote flows. Real builds include ASAP & CO. and Briars Unlimited.",
        intro: "People judge a print shop by its prints. Your website should show real work, make pricing obvious, and take quote requests while you sleep.",
        image: "/assets/client-briars.webp",
        imageAlt: "Briars Unlimited custom apparel website designed by Camarca Digital Designs",
        needs: [
            "Quote request flow",
            "Product catalog or online shop",
            "Gallery of real work",
            "Clear pricing tables",
            "Bulk order information",
            "Rush & turnaround details",
        ],
        paragraphs: [
            "I've built sites for two custom apparel businesses: ASAP & CO. Custom Print Group — a bold storefront covering DTF transfers, UV printing, stickers, and bulk orders — and Briars Unlimited, a family-run New Jersey shop with a full online store, catalog, and gallery.",
            "Whether you sell through a shop or through quotes, your site gets a gallery that shows off real jobs and a quote flow that captures every detail you need to price the work right the first time.",
        ],
        clients: ["asap-co", "briars-unlimited"],
        cta: "Run a print shop or apparel brand?",
    },
    {
        slug: "trailer-dealership-website-design",
        label: "Trailer & Shed Dealers",
        h1: "Trailer & Shed Dealership Website Design",
        seoTitle: "Trailer & Shed Dealership Website Design — Camarca Digital Designs",
        seoDescription: "Website design for trailer, shed and equipment dealers: live inventory with photos and pricing, financing and rent-to-own applications, reviews and directions. Built for GAP Outdoors, Ohio.",
        intro: "Trailers and sheds are big-ticket purchases. Buyers research online long before they visit your lot — your website has to build that trust first.",
        image: "/assets/client-gap.webp",
        imageAlt: "GAP Outdoors trailer dealership website designed by Camarca Digital Designs",
        needs: [
            "Live inventory with photos & pricing",
            "Financing & rent-to-own applications",
            "Customer reviews",
            "Location, hours & directions",
            "Click-to-call buttons",
            "Buy, sell & trade information",
        ],
        paragraphs: [
            "GAP Outdoors in Williamsburg, Ohio runs on a Camarca build: live inventory with photos and out-the-door pricing, rent-to-own and financing applications, Google reviews, and directions — everything a buyer needs before making the drive.",
            "If you sell trailers, sheds, or equipment, I'll build you a lot that never closes — one that answers every question before the customer ever calls.",
        ],
        clients: ["gap-outdoors"],
        cta: "Run a dealership or equipment lot?",
    },
    {
        slug: "home-services-website-design",
        label: "Home & Trade Services",
        h1: "Home Services Website Design",
        seoTitle: "Home Services Website Design | Plumbers, HVAC, Pressure Washing — Camarca Digital Designs",
        seoDescription: "Website design for home service and trade businesses: fast quote forms, click-to-call, service area pages and trust signals. Real builds and concepts for floor safety, plumbing, HVAC, lawn care and more.",
        intro: "When someone's floor is slippery or their driveway needs washing, they pick the business that looks the most legit on Google. That should be you.",
        image: "/assets/client-kinetic.webp",
        imageAlt: "Kinetic Facilities home services website designed by Camarca Digital Designs",
        needs: [
            "Fast quote request form",
            "Click-to-call on every screen",
            "Clear service explanations",
            "Service area information",
            "Trust badges & certifications",
            "Before & after photos",
        ],
        paragraphs: [
            "Kinetic Facilities — an authorized Sure Step non-slip floor treatment distributor near Cincinnati — got a site that explains an unfamiliar product in seconds and keeps the call button one tap away at all times.",
            "I also design for plumbers, HVAC companies, lawn care, pressure washing, auto shops, and salons — you can browse design concepts for each on my Work page.",
        ],
        clients: ["kinetic-facilities"],
        cta: "Run a service or trade business?",
    },
];
